import type { Locale } from "./domain";

export function money(millimes: number, locale: Locale): string {
  return new Intl.NumberFormat(locale === "ar" ? "ar-TN-u-nu-latn" : "fr-TN", {
    currency: "TND",
    minimumFractionDigits: 3,
    style: "currency",
  }).format(millimes / 1_000);
}

export function time(value: string, locale: Locale): string {
  return new Intl.DateTimeFormat(locale === "ar" ? "ar-TN-u-nu-latn" : "fr-TN", {
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(value));
}

export function localName(value: { ar: string | null; fr: string | null }, locale: Locale) {
  return value[locale] ?? value.ar ?? value.fr ?? "";
}

export function dateRange(days = 30): { from: string; to: string } {
  const to = new Date();
  const from = new Date(to);
  from.setDate(from.getDate() - days);
  return { from: isoDate(from), to: isoDate(to) };
}

function isoDate(value: Date): string {
  return value.toISOString().slice(0, 10);
}
